export const ManageCouponConfig = {
    columns:[
        {headerName:"Coupon ID",mappedValue:"discountId",width:200},
        {headerName:"Coupon description",mappedValue:"schemeDescription",width:400},
        {headerName:"Coupon Start Date",mappedValue:"startDate",width:200},
        {headerName:"Coupon End Date",mappedValue:"endDate",width:200},
        {headerName:"Coupon Type",mappedValue:"type",width:200}
    ],
    Actions:[
        "shortClose"
    ]
}